import { render, staticRenderFns } from "./SYBuyList.vue?vue&type=template&id=364a32e6&scoped=true&"
import script from "./SYBuyList.vue?vue&type=script&lang=js&"
export * from "./SYBuyList.vue?vue&type=script&lang=js&"
import style0 from "./SYBuyList.vue?vue&type=style&index=0&id=364a32e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a32e6",
  null
  
)

export default component.exports